import { faArrowRight, faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface LocateFinishedMessageProps {
  onFinish?: () => void;
}

export const LocateFinishedMessage: React.FC<LocateFinishedMessageProps> = ({
  onFinish,
}) => {
  const { t } = useTranslation('locationordersDetailModule');
  const navigate = useNavigate();

  const handleBack = () => {
    if (onFinish) {
      onFinish();
    } else {
      navigate('/location-orders');
    }
  };

  return (
    <div className="bg-green-50 dark:bg-green-950/20 border border-green-200 dark:border-green-800 rounded-lg p-6">
      <div className="flex flex-col items-center space-y-4">
        <div className="flex items-center space-x-3">
          <FontAwesomeIcon
            icon={faCheckCircle}
            className="w-6 h-6 text-green-500"
          />
          <span className="text-lg font-medium text-green-700 dark:text-green-300">
            {t('locate.finished_title', { defaultValue: 'Ubicación completada' })}
          </span>
        </div>

        <p className="text-muted-foreground text-center">
          {t('locate.finished_message', {
            defaultValue: 'Todos los artículos han sido ubicados correctamente',
          })}
        </p>

        <button
          onClick={handleBack}
          className="flex items-center justify-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2.5 rounded-lg font-medium transition-colors min-w-[140px]"
          data-testid="go-to-location-orders-button"
        >
          <FontAwesomeIcon icon={faArrowRight} className="w-4 h-4" />
          <span>{t('ui.back_to_returned', { defaultValue: 'Volver a Órdenes de ubicación' })}</span>
        </button>
      </div>
    </div>
  );
};
